import EditFieldModal from "@/modules/common/components/modals/edit-field-modal";
import FullScreenDialog from "@/modules/common/components/modals/full-screen-modal";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import EditStatusForm from "@/modules/lead-page/components/lead-info/edit-fields/status/edit-status-form";
import { useLeadContext } from "@/modules/lead-page/context/lead-page.context";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import Status from "@/modules/common/components/ui-kit/status/status";
import { Box, Typography, useTheme } from "@mui/material";
import { useContext } from "react";
import { userHasPermission } from "@/modules/common/utils";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";

const StatusField = () => {
  const { handleConfirmUpdate, status, isLoading } = useLeadInfo();
  const theme = useTheme();

  const screen = useScreenSize();
  const { lead, isAssignedAgent } = useLeadContext();

  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);

  const preventEditStatus = userHasPermission(
    { name: PermissionsEnum.PREVENT_EDIT_STATUS, level: PermissionLevel.WRITE },
    currentUserPermissions
  );

  return (
    <>
      <Box
        sx={{
          height: "100%",
          width: {
            mobile: "100%",
            tablet: "100%",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            flex: 1,
            flexDirection: "column",

            justifyContent: screen.isMobile ? "flex-start" : "flex-end",
            gap: theme.nawy.spacing.xxs,
          }}
        >
          <Typography
            sx={{
              fontSize:
                theme.nawy.typography.english.variants.body.xs.regular.fontSize,
              fontWeight:
                theme.nawy.typography.english.variants.body.xs.regular
                  .fontWeight,
              lineHeight:
                theme.nawy.typography.english.variants.body.xs.regular
                  .lineHeight,
            }}
            color={theme.nawy.colors.primitives.grey[700]}
          >
            {lead?.data?.lead?.status?.nextStatusCategory?.name
              ? lead?.data?.lead?.status?.nextStatusCategory?.name
              : lead?.data?.lead?.status?.statusCategory?.name}
          </Typography>
          <Status
            data-testid="lead-status-button"
            label={`${lead?.data?.lead?.status?.status}`}
            bgHexColor={lead?.data?.lead?.status?.color}
            size="lg"
            variant="secondary"
            onClick={() =>
              (!preventEditStatus || isAssignedAgent) &&
              status.setEditLeadStatusModalOpen(true)
            }
          />
        </Box>
      </Box>

      {screen.isMobile ? (
        <FullScreenDialog
          open={status.editLeadStatusModalOpen}
          setOpen={status.setEditLeadStatusModalOpen}
          header="Edit Status"
          handleCloseModal={() => status.setEditLeadStatusModalOpen(false)}
        >
          {status.data && (
            <EditStatusForm
              isLoadingSubmition={isLoading}
              handleConfirmUpdate={handleConfirmUpdate}
              status={{ ...status, data: status.data }}
            />
          )}
        </FullScreenDialog>
      ) : (
        <EditFieldModal
          header="Edit Status"
          open={status.editLeadStatusModalOpen}
          setOpen={status.setEditLeadStatusModalOpen}
          width={700}
          modalFooter={false}
          testId="edit-status-modal"
        >
          {status.data && (
            <EditStatusForm
              isLoadingSubmition={isLoading}
              handleConfirmUpdate={handleConfirmUpdate}
              status={{ ...status, data: status.data }}
            />
          )}
        </EditFieldModal>
      )}
    </>
  );
};

export default StatusField;
